import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";
import MyChartContainer from "../mychart/MyChartContainer";

const Letters = (props) => {
    logUI("MBHWeb.UI.Letters.ComponentDidMount", new Date(), Tools.getURLPath());
    const serverData = props.serverData;
    const heading = (
        <div className="mychart-btn-container--full-width bswh-mychart-overlay">
            <Link className="btn btn-primary" to={{ pathname: "/messagesAll" }}>
                Messages
            </Link>
        </div>);

    return <MyChartContainer mode="letters" title="Letters" heading={heading} serverData={serverData} />;
};

export default Letters;